<template>
  <v-dialog
    v-model:visible="open"
    modal
    :show-header="false"
    class="rounded border-primary bg-primary pt-3"
    style="max-width: 50ch; overflow:hidden;"
    position="center"
  >
    <section class="text-center" v-html="name"></section>
    <section class="pt-3 text-start">
      <div class="d-flex justify-content-center mb-3">
        <a id="tell-us" class="btn btn-light" :href="url">{{ accept }}</a>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-link" @click="open = false">
          {{ deny }}
        </button>
      </div>
    </section>
  </v-dialog>
</template>

<script setup lang="ts">
import VDialog from "primevue/dialog";
import { ref } from "vue";

interface Props {
  name: string;
  url: string;
  accept: string;
  deny: string;
}
defineProps<Props>();

const open = ref(true);
</script>

<style lang="scss" scoped>
#tell-us {
  width: 200px;
  max-height: 40px;
}

.btn-link {
  font-size: 0.875em;
  &:hover {
    color: white;
  }
  color: white;
  text-decoration: none;
}

.p-dialog {
  text-align: center;
  padding: 0 !important;
}
</style>
